import type { MutationHookOptions } from '@apollo/client';

/**
 * Shared mutation options for `customFieldValueBulkSave` callers.
 *
 * Every call site that writes custom-field values has to invalidate every
 * cached `customFieldValueMany` result — the page-level query, the calendar's
 * batched `_operators.recordId.in:[...]` query, and any future read sites all
 * key differently in Apollo's cache. A blanket fieldName eviction + gc is the
 * only reliable invalidation pattern that catches them all.
 *
 * Spread the return value into a `useMutation` call's options:
 *
 *     useCustomFieldValueBulkSaveMutation({
 *       ...customFieldValueMutationOptions(),
 *       refetchQueries: [...],   // optional, page-specific exact-filter refetch
 *     });
 */
export function customFieldValueMutationOptions(): Pick<
  MutationHookOptions,
  'update'
> {
  return {
    update(cache) {
      cache.evict({ fieldName: 'customFieldValueMany' });
      cache.gc();
    },
  };
}
